import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Card, Tabs, Select, Modal, message, Input, Checkbox } from "antd";
import { Table } from "components";
import Immutable, { OrderedMap, Map, List } from "immutable";
// import cx from "classnames";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import {
    INPUT_TYPES, COMPANY_TYPES,
    HOLDBACK_TYPE,
    HOLDBACK_SUB_TYPE,
    PROGRAM_TYPE,
    BUSINESS_TYPE,
} from "constants/index";
import { CompanyService } from "services/index";
import "styles/tabs.css";
import moment from "moment";
import companyLosServices from "../services/company-los-services";

const { Option } = Select;


const getDistFormFields = ({
    gstinValidator,
    getChannelProducts,
    allFieldsDisabled,
    fetchIndustryTypes,
}) =>
    new OrderedMap({
        gstin: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "GSTIN",
            // rules: [
            //     {
            //         required: true,
            //         message: "GSTIN is Required"
            //     },
            //     gstinValidator
            // ],
            disabled: true,
            category: 1
        },
        name: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Name",
            // rules: [
            //     {
            //         required: true,
            //         message: "Name is Required"
            //     }
            // ],
            disabled: true,
            category: 1
        },
        type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Company Type",
            // options: COMPANY_TYPES.map((value, label) => ({
            //     label,
            //     value: value
            // }))
            //     .toList()
            //     .toArray(),
            category: 1
        },
        primary_brand: {
            className: "form-field fb-30 mr-3perc",
            label: "Primary Brands",
            type: INPUT_TYPES.OBJECT_SELECT,
            getOptionsOnFocus: getChannelProducts,
            labelProp: "name|id",
            rules: [
                {
                    required: true,
                    message: "Primary Brands is Required"
                },
            ],
            filterOption: true,
            category: 1
        },
        industry: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.OBJECT_SELECT,
            label: "Primary Industry",
            category: 1,
            labelProp: "name|id",
            rules: [
                {
                    required: true,
                    message: "Primary Industry is Required"
                },
            ],
            filterOption: true,
            getOptionsOnFocus: fetchIndustryTypes,
        },
        business_type:{
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Business type",
            rules: [
                {
                    required: true,
                    message: "Business type is Required"
                },
            ],
            options: BUSINESS_TYPE.map((value, label) => ({
                label,
                value: value
            }))
                .toList()
                .toArray(),
            category: 1
        },
        program_type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Program Type",
            rules: [
                {
                    required: true,
                    message: "Program Type is Required"
                },
            ],
            options: PROGRAM_TYPE.map((value, label) => {
                return({
                    label,
                    value: value
                });})
                .toList()
                .toArray(),
            disabled: allFieldsDisabled,
            category: 1,
        },
        proposed_program_size_in_cr: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            showSearch: true,
            label: "Proposed Program Size(Crores)",
            category: 1,
            rules: [
                {
                    required: true,
                    message: "Proposed Program Size(Crores) is Required"
                },
                {
                    pattern: /^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                    message: "Please enter a valid positive value with upto 3 places",
                },
            ],
            labelProp: "name",
        },
        proposed_max_ticket_size_in_lacs: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            showSearch: true,
            label: "Proposed Max Ticket Size(Lakhs)",
            disabled: allFieldsDisabled,
            category: 1,
            labelProp: "name",
            filterOption: true,
            rules: [
                {
                    required: true,
                    message: "Proposed Max Ticket Size(Lakhs) is Required"
                },
                {
                    pattern:/^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                    message: "Please enter a valid positive value with upto 3 places",
                },
            ],
            getOptionsOnFocus: fetchIndustryTypes,
            onSearch: fetchIndustryTypes
        },
    });

const getUserDetails = (allFieldsDisabled) => new OrderedMap({
    proposed_tenor: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Proposed Tenor",
        disabled: allFieldsDisabled,
        rules: [
            {
                required: true,
                message: "Proposed Tenor is Required"
            },
            {
                pattern: /^(?!0+$)[1-9]\d*$/,
                message: "Please enter a valid positive integer",
            },
        ],
        category: 2
    },
    hold_back_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Holdback Type",
        rules: [
            {
                required: true,
                message: "Holdback Type is Required"
            },
        ],
        options: HOLDBACK_TYPE.map((value, label) => ({
            label,
            value: value
        }))
            .toList()
            .toArray(),
        disabled: allFieldsDisabled.label,
        category: 2
    },
    hold_back_sub_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Holdback sub-type",
        rules: [
            {
                required: true,
                message: "Holdback sub-type is Required"
            },
        ],
        options: HOLDBACK_SUB_TYPE.map((value, label) => {
            return({
                label,
                value: value
            });})
            .toList()
            .toArray(),
        disabled: allFieldsDisabled,
        category: 2
    },
    margin: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Margin %",
        disabled: allFieldsDisabled,
        rules: [
            {
                required: true,
                message: "Margin % is Required"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Value should be positive",
            },
        ],
        category: 2
    },
    roi_min: {
        label: "ROI %(Min)",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "ROI %(Min) is Required"
            },
            {
                pattern: /^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                message: "Please enter a valid positive value with upto 3 places",
            },
        ],
        className: "form-field fb-14 mr-3perc",
        // category: 2,
    },
    roi_max: {
        label: "ROI %(Max)",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "ROI %(Max) is Required"
            },
            {
                pattern: /^(?!0+(\.0*)?$)\d*\.?\d{1,3}$/,
                message: "Please enter a valid positive integer",
            },
        ],
        className: "form-field fb-14 mr-3perc",
        category: 2,
        disabled: allFieldsDisabled
    },
    sbd_days: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "SBD Days",
        rules: [
            {
                required: true,
                message: "SBD Days is Required"
            },
            {
                pattern: /^(?!0+$)[1-9]\d*$/,
                message: "Please enter a valid positive integer",
            },
        ],
        category: 2
    },
    subvention: {
        label: "Subvention",
        type: INPUT_TYPES.SELECT,
        rules: [
            {
                required: true,
                message: "Subvention % is Required"
            }
        ],
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        className: "form-field fb-30 mr-3perc"
    },
    subvention_perc: {
        label: "Subvention %",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Subvention % is Required"
            },
            {
                pattern: /^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                message: "Please enter a valid positive integer",
            },
        ],
        className: "form-field fb-30 mr-3perc"
    },
    subvention_days: {
        label: "Subvention Days",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Subvention Days is Required"
            },
            {
                pattern: /^(?!0+$)[1-9]\d*$/,
                message: "Please enter a valid positive integer",
            },
        ],
        className: "form-field fb-30 mr-3perc"
    },
    overdue_roi: {
        label: "Overdue ROI %",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Overdue ROI % is Required"
            },
            {
                pattern: /^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                message: "Please enter a valid positive integer",
            },
        ],
        className: "form-field fb-30 mr-3perc"
    },
});
const getScheduleCharges = (allFieldsDisabled) => new OrderedMap({
    loan_processing_fee: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Loan Processing Fee",
        disabled: allFieldsDisabled,
        rules: [
            {
                required: true,
                message: "Loan Processing Fee is Required"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid positive integer",
            },
        ],
        category: 3
    },
    documentation_charges: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Documentation charges",
        rules: [
            {
                required: true,
                message: "Documentation charges is Required"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid positive integer",
            },
        ],
        disabled: allFieldsDisabled.label,
        category: 3
    },
    cheque_bounce_charges: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Cheque Bounce Charges",
        disabled: allFieldsDisabled.label,
        rules: [
            {
                required: true,
                message: "Cheque Bounce Charges is Required"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid positive integer",
            },
        ],
        category: 3
    },
});
const getApprovalDetails = () => new OrderedMap({
    approval_date: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.DATE,
        label: "Approval Date",
        rules: [
            {
                required: true,
                message: "Approval Date is Required"
            },
        ],
        category: 4
    },
    ccm_meeting_date: {
        className: "form-field fb-30",
        type: INPUT_TYPES.DATE,
        label: "CCM Meeting Date",
        rules: [
            {
                required: true,
                message: "CCM Meeting Date is Required"
            },
        ],
        category: 4
    },
    eml_file: {
        className: "form-field fb-30",
        type: INPUT_TYPES.FILE,
        label: "EML file upload",
        accept:"message/rfc822",
        rules: [
            {
                required: true,
                message: "EML file upload is Required"
            },
        ],
        fileList : [],
        showUploadList : true,
        category: 4
    },
});

const getSupportingDocumentsSales = () => new OrderedMap({
    download_documents_by_sales: {
        className: "form-field fb-40 mr-3perc",
        type: INPUT_TYPES.BUTTON,
        btnType: "download",
        icon:" download",
        onClick: ()=> {fetch("https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Deviation_Matrix_Template.xlsx")
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Deviation_Matrix_Template.xlsx";
                link.click();
            })
            .catch(console.error);},
        placeholder: "Download Deviation Matrix",
        // disabled: allFieldsDisabled,
        category: 6
    },
    supporting_documents_by_sales: {
        className: "form-field fb-40",
        type: INPUT_TYPES.FILE,
        accept: ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        label: "Upload Deviation Matrix",
        fileList : [],
        viewable: true,
        showUploadList : true,
        category: 6,
    },
});
const getSupportingDocumentsCredit = () => new OrderedMap({
    download_documents_by_sales: {
        className: "form-field fb-25",
        type: INPUT_TYPES.BUTTON,
        btnType: "download",
        icon:" download",
        onClick: ()=> {fetch("https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Deviation_Matrix_Template.xlsx")
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Deviation_Matrix_Template.xlsx";
                link.click();
            })
            .catch(console.error);},
        placeholder: "Download Deviation Matrix",
        // disabled: allFieldsDisabled,
        category: 6
    },
    supporting_documents_by_sales: {
        className: "form-field fb-15",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        icon:"download",
        shape:"round",
        placeholder: "",
        label: "Document By Sales",
        viewable: true,
        category: 6,
        onClick: (e)=> {
            if(e.target.value){
                const anchor = document.createElement("a");
                anchor.href = e.target.value;
                anchor.download = e.target.value;
                anchor.click();
            }else{
                message.error("No file present");
            }
        },
    },
    // supporting_documents_by_credit: {
    //     className: "form-field fb-15 mr-3perc",
    //     type: INPUT_TYPES.BUTTON,
    //     btnType: "link",
    //     icon:"download",
    //     shape:"round",
    //     label: "Document By Credit",
    //     showPreview: true,
    //     // label: (e)=>getFileNameFromUrl(e.target.value),
    //     onClick: (e)=> {
    //         if(e.target.value){
    //             const anchor = document.createElement("a");
    //             anchor.href = e.target.value;
    //             anchor.download = e.target.value;
    //             anchor.click();
    //         }else{
    //             message.error("No file present");
    //         }
    //     },
    //     category: 6
    // },
    supporting_documents_by_credit: {
        className: "form-field fb-15",
        type: INPUT_TYPES.FILE,
        accept: ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        viewable: true,
        // editable: true,
        label: "Upload Deviation Matrix",
        // onChange: onChangeCreditDoc,
        // disabled: allFieldsDisabled.label,
        category: 6,
        fileList : [],
        showUploadList : true
    },
});

const getCommentsMpa = () => new OrderedMap({
    sales_remarks: {
        className: "form-field w-40 mr-3perc description-field",
        type: INPUT_TYPES.TEXTAREA,
        // label: "Comments (Sales)",
        placeholder: "Comments (Sales)",
        size: "large",
        rules: [
            {
                required: true,
                message: "Comments (Sales) is Required"
            }
        ],
        onChange: null,
        category: 5
    },
    credit_remarks: {
        className: "form-field description-field w-40 mr-3perc",
        type: INPUT_TYPES.TEXTAREA,
        // label: "Comments (Credit)",
        placeholder: "Comments (Credit)",
        onChange: null,
        rules: [
            {
                required: true,
                message: "Comments (Credit) is Required"
            }
        ],
        category: 5
    },
});

class MpaCreateForm extends React.Component {

    state = {
        deviation_agreed_para: [],
        deviationObj: [],
        deviationAgreedData: [],
        isFetchedDeviationData: false,
        additionalDocs: []
    };
    componentDidMount() {
        CompanyService.getMpaApprovalParaCriteria().then(res=>{
            this.setState({deviation_agreed_para: res.data});
        }).catch((err) => {
            console.error(err);
        });
        companyLosServices.fetchDocumentMasterList().then(response => {
            const documents_name_data = response?.data?.map(el=>el.document_name);
            this.setState({additionalDocs: documents_name_data});
        });
    }

    componentDidUpdate() {
        if (
            JSON.stringify(this.state.deviationAgreedData) !== this.props.mpaData && JSON.stringify(this.props.mpaData?.getIn(["deviation_list"])?.toJS()) &&
          !this.state.isFetchedDeviationData
        ) {
            this.setState({
                deviationAgreedData: [...this.props.mpaData?.getIn(["deviation_list"])?.toJS()],
                isFetchedDeviationData: true,
            });
        }
    }
      

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, { users, bank_details, ...restValues }) => {
                if(err){
                    console.log("inside submit err", err);
                    return;
                }
                const supporting_documents_by_sales = this.props.form.getFieldValue("supporting_documents_by_sales");
                const supporting_documents_by_credit = this.props.form.getFieldValue("supporting_documents_by_credit");
                const eml_file = this.props.form.getFieldValue("eml_file");
                let formDataJson = new FormData();
                if(Number(restValues?.roi_min) > Number(restValues.roi_max)){
                    message.error("ROI max must be greater than ROI min.");
                    return;
                }
                
                if(Number(restValues?.proposed_max_ticket_size_in_lacs) > Number(restValues.proposed_program_size_in_cr * 100)){
                    message.error("Proposed Max Ticket Size must be less than Program Size.");
                    return;
                }
                if(Number(restValues?.roi_max) > Number(restValues.overdue_roi)){
                    message.error("Overdue ROI is always greater than ROI max.");
                    return;
                }
                if (typeof eml_file === "object" && this.props.creditPermission){
                    formDataJson.append("is_eml_file_uploaded", false);
                    // message.error("Please upload EML file type");
                }

                
                if (!supporting_documents_by_credit && this.props.creditPermission) {
                    message.error("Please upload supporting documents by credit.");
                    return;
                }
                if(supporting_documents_by_credit){
                    const {approval_date, ccm_meeting_date, industry, primary_brand, supporting_documents_by_sales, ...mpaJson} = {...restValues};
                    Object.keys(mpaJson).filter((key) => mpaJson[key] !== undefined).map(el=>{
                        formDataJson.append(el,restValues[el]);
                    });
                }else{
                    const {approval_date, ccm_meeting_date, industry, primary_brand, ...mpaJson} = {...restValues};
                    Object.keys(mpaJson).filter((key) => mpaJson[key] !== undefined).map(el=>{
                        formDataJson.append(el,restValues[el]);
                    });
                }
                if(typeof supporting_documents_by_sales === "string" && this.props.salesPermission){
                    formDataJson.append("is_document_uploaded_by_sales", true);
                    formDataJson.append("is_document_uploaded_by_credit", true);
                    formDataJson.delete("supporting_documents_by_sales");
                }
                if(typeof supporting_documents_by_sales !== "string" && this.props.salesPermission){
                    formDataJson.append("is_document_uploaded_by_sales", false);
                    formDataJson.append("is_document_uploaded_by_credit", false);
                }
                if (typeof eml_file === "string" && eml_file && eml_file?.endsWith(".eml") && this.props.creditPermission){
                    formDataJson.append("is_eml_file_uploaded", true);
                    formDataJson.delete("eml_file");
                    formDataJson.append("eml_file", "");
                }
                if(restValues.approval_date){
                    formDataJson.append("approval_date", restValues.approval_date?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"));
                }
                if(restValues.ccm_meeting_date){
                    formDataJson.append("ccm_meeting_date", restValues.ccm_meeting_date?.format("YYYY-MM-DD"));
                }
                if(restValues.subvention === false){
                    formDataJson.delete("subvention_perc");
                    formDataJson.delete("subvention_days");
                    formDataJson.append("subvention_perc", "");
                    formDataJson.append("subvention_days", "");

                }
                if(!supporting_documents_by_credit && this.props.creditPermission){
                    formDataJson.append("is_document_uploaded_by_sales", true);
                    formDataJson.append("is_document_uploaded_by_credit", true);
                    formDataJson.delete("supporting_documents_by_credit");
                    formDataJson.delete("supporting_documents_by_sales");
                }
                if(supporting_documents_by_credit && this.props.creditPermission){
                    formDataJson.append("is_document_uploaded_by_sales", false);
                    formDataJson.append("is_document_uploaded_by_credit", false);
                    formDataJson.delete("supporting_documents_by_credit");
                    formDataJson.append("supporting_documents_by_credit", supporting_documents_by_credit);
                }
              
                // if(supporting_documents_by_credit && this.props.creditPermission){
                //     console.log("inside if 3");
                //     formDataJson.delete("supporting_documents_by_credit");
                //     formDataJson.delete("supporting_documents_by_sales");
                //     formDataJson.append("supporting_documents_by_credit", supporting_documents_by_credit);
                //     formDataJson.append("is_document_uploaded_by_sales", false);
                //     formDataJson.append("is_document_uploaded_by_credit", false);
                // }
                // if(this.state.deviationAgreedData.length ===1 && this.state.deviationAgreedData[0].parameter === ""){
                //     message.error("Please fill deviation agreed parameters");
                //     return;
                // }
                formDataJson.append("industry", restValues.industry?.id);
                formDataJson.append("primary_brand", restValues.primary_brand?.id);
                formDataJson.append("deviation_list", JSON.stringify(this.state.deviationAgreedData));
                this.props.loadingFn(true);
                CompanyService.postMpaDataApi(this.props.companyId, formDataJson).then(res=>{
                    if(res.status === 200){
                        message.success("Request has been submitted");
                        this.props.getMpaRequest();
                    }
                }).catch(err=>{
                    console.log("inside catch", err);
                    this.props.loadingFn(false);
                    if(err && Object.keys(err).length>0){
                        Array.isArray(Object.keys(err)) && Object.keys(err).map(el=>{
                            message.error(`${el}:${err[el]}`);
                        });
                    }
                });
            });
        }
    };


    distFormFields = getDistFormFields({
        gstinValidator: this.props.gstinValidator,
        getChannelProducts: this.props.fetchChannelProducts,
        salesManagers: this.props.fetchSalesManagers,
        distributorManagers: this.props.fetchDistributorManagers,
        vpSalesManagers: this.props.fetchVpSalesManagers,
        drmManagers: this.props.fetchDRMManagers,
        allFieldsDisabled: this.props.loading,
        gstinDisabled: this.props.gstinDisabled,
        fetchIndustryTypes: this.props.fetchIndustryTypes
    });

    userFormFields = getUserDetails(this.props.loading);
    scheduleChargesFormFields = getScheduleCharges(this.props.loading);
    approvalDetailsFormFields = getApprovalDetails(this.props.creditPermission);
    commentsFormFields = getCommentsMpa(this.props.loading);
    supportingDocumentsFormFieldsSales = getSupportingDocumentsSales(this.props.loading);
    supportingDocumentsFormFieldsCredit = getSupportingDocumentsCredit(this.props.loading);

    getDistributorCompanyForm = () => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row align-items-center flex-wrap w-100"}>
                {this.distFormFields.map((field, fieldName) => {
                    field.disabled = this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status"))  || this.props.creditPermission && this.props.mpaData?.get("current_status") === "Approved";
                    if(fieldName === "type"){
                        field.disabled = true;
                    }
                    if (fieldName === "gstin") {
                        field.disabled = true;
                    }
                    if (fieldName === "name") {
                        field.disabled = true;
                    }
                    if(fieldName === "industry"){
                        field.onChange = this.setIndustryAndAnchor;
                        field.rules = [
                            {
                                required: true,
                                message: "Field Required"
                            }
                        ];
                    }
                    
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </div>
        </Card>
    );

    setIndustryAndAnchor = industry => {
        this.props.form.setFieldsValue({
            "industry": industry,
        });
    }

    onSelectSubvention = (val) => {
        if(val === false){
            this.props.form.setFieldsValue({subvention_days: "", subvention_perc: ""});
        }
    }
    onSelectHoldbackType = (val) => {
        if(val !== 1){
            this.props.form.setFieldsValue({hold_back_sub_type: ""});
        }
    }
    getUserDetailsForm = () => (
        <Card className={"no-shadow border-none"}>
            <div>
                {
                    <div 
                        className={"d-flex flex-row align-items-center flex-wrap w-100 mb-10"}
                    >
                        {this.userFormFields.map((field, fieldName) => {
                            field.disabled = this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status"))  || this.props.creditPermission && this.props.mpaData?.get("current_status") === "Approved";
                            if(fieldName === "subvention"){
                                field.onSelect = this.onSelectSubvention;
                            }
                            if(fieldName === "hold_back_type"){
                                field.onSelect = this.onSelectHoldbackType;
                            }
                            if(this.props.form.getFieldValue("subvention") === false && (fieldName === "subvention_days" || fieldName === "subvention_perc")){
                                field.disabled = true;
                                field.rules = [];
                            }else if(this.props.form.getFieldValue("subvention") && (fieldName === "subvention_days") && !["Approved", "Awaiting Approval"].includes(this.props.mpaData?.get("current_status"))){
                                field.disabled = false;
                                field.rules =  [
                                    {
                                        required: true,
                                        message: "Subvention days is Required"
                                    },
                                    {
                                        pattern: /^(?!0+$)[1-9]\d*$/,
                                        message: "Please enter a valid positive integer",
                                    },
                                ];
                            }else if(this.props.form.getFieldValue("subvention") && fieldName === "subvention_perc" && !["Approved", "Awaiting Approval"].includes(this.props.mpaData?.get("current_status"))){
                                field.disabled = false;
                                field.rules =  [
                                    {
                                        required: true,
                                        message: "Subvention Perc is Required"
                                    },
                                    {
                                        pattern: /^(?!0+(\.0*)?$)\d+(\.\d{1,3})?$/,
                                        message: "Please enter a valid positive integer",
                                    },
                                ];
                            }
                            if(this.props.form.getFieldValue("hold_back_type") !== 1 && fieldName === "hold_back_sub_type"){
                                field.disabled = true;
                                field.rules = [];
                            }else if(this.props.form.getFieldValue("hold_back_type") === 1 && fieldName === "hold_back_sub_type"  && !["Approved", "Awaiting Approval"].includes(this.props.mpaData?.get("current_status"))){
                                field.disabled = false;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Holdback Subtype is mandatory"
                                    }
                                ];
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                // this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                }
            </div>
        </Card>
    );
    getScheduleCharges = () => (
        <Card className={"no-shadow border-none"}>
            <div>
                {
                    <div 
                        className={"d-flex flex-row align-items-center flex-wrap w-100 mb-10"}
                    >
                        {this.scheduleChargesFormFields.map((field, fieldName) => {
                            field.disabled = this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status"))  || this.props.creditPermission && this.props.mpaData?.get("current_status") === "Approved";
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                // this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                }
            </div>
        </Card>
    );
    getApprovalDetails = () => (
        <Card className={"no-shadow border-none"}>
            <div>
                {
                    <div 
                        className={"d-flex flex-row align-items-center flex-wrap w-100 mb-10"}
                    >
                        {this.approvalDetailsFormFields.map((field, fieldName) => {
                            field.disabled = this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status"))  || this.props.creditPermission && this.props.mpaData?.get("current_status") === "Approved";
                            const emlFile = this.props.form.getFieldValue("eml_file");
                            let fileListEml;
                            if (typeof emlFile === "string") {
                                if (emlFile?.length > 20) {
                                    const firstPart = emlFile?.substring(0, 20);
                                    const lastPart = emlFile?.substring(emlFile?.length - 20);
                                    const shortenedUrl = `${firstPart}...${lastPart}`;
                                    fileListEml = {
                                        uid: "-1",
                                        name: shortenedUrl,
                                        status: "done",
                                        url: emlFile,
                                    };
                                }
                            } else if(typeof emlFile === "object"){
                                if (emlFile?.name?.length > 20) {
                                    const firstPart = emlFile?.name?.substring(0, 20);
                                    const lastPart = emlFile?.name?.substring(emlFile?.name?.length - 20);
                                    const shortenedUrl = `${firstPart}...${lastPart}`;
                                    fileListEml = {
                                        uid: "-1",
                                        name: "",
                                        status: "done",
                                        url: "",
                                    };
                                }
                            }
                            else {
                                console.log("Substring not found");
                            }
                            if ( fieldName === "eml_file" && emlFile){
                                // field.disabled = true;
                                field.fileList = [ fileListEml];
                                field.showUploadList = true;
                            }
                            if ( fieldName === "eml_file" && emlFile && typeof emlFile === "object"){
                                // field.disabled = true;
                                field.fileList = [ ];
                                field.showUploadList = false;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                }
            </div>
        </Card>
    );
    getComments = () => (
        <Card className={"no-shadow border-none"}>
            <div>
                {
                    <div 
                        className={"d-flex flex-row justify-content-space-between align-items-center flex-wrap w-100 mb-10"}
                    >
                        {this.commentsFormFields.map((field, fieldName) => {
                            field.disabled = this.props.disableFields;
                            if (fieldName === "sales_remarks" && (this.props.creditPermission || this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status")))) {
                                field.disabled = true;
                                field.rules = [];
                            }
                            if (fieldName === "credit_remarks" && (!this.props.creditPermission || this.props.mpaData?.get("current_status") === "Approved")) {
                                field.disabled = true;
                                field.rules = [];
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                }
            </div>
        </Card>
    );
    formFieldsSupportingDocs = this.props.creditPermission
        ? this.supportingDocumentsFormFieldsCredit :
        this.props.salesPermission
            ? this.supportingDocumentsFormFieldsSales
            : null;
    getSupportingDocuments = () =>(
        <Card className={"no-shadow border-none"}>
            <div>
                {
                    <div 
                        className={"d-flex flex-row align-items-center justify-content-space-between flex-wrap w-100 mb-10"}
                    >
                        {
                            this.formFieldsSupportingDocs?.map((field, fieldName) => {
                                field.disabled = this.props.salesPermission && ["Awaiting Approval", "Approved"].includes(this.props.mpaData?.get("current_status"))  || this.props.creditPermission && this.props.mpaData?.get("current_status") === "Approved";
                                const supportingDocumentsByCredit = this.props.form.getFieldValue("supporting_documents_by_credit");
                                const supportingDocumentsBySales = this.props.form.getFieldValue("supporting_documents_by_sales");
                                let fileListCredit;
                                let fileListSales;
                                let shortenedUrlSales;
                                if (typeof supportingDocumentsByCredit === "string") {
                                    if (supportingDocumentsByCredit?.length > 20) {
                                        const firstPart = supportingDocumentsByCredit?.substring(0, 20);
                                        const lastPart = supportingDocumentsByCredit?.substring(supportingDocumentsByCredit?.length - 20);
                                        const shortenedUrl = `${firstPart}...${lastPart}`;
                                        fileListCredit = {
                                            uid: "-1",
                                            name: shortenedUrl,
                                            status: "done",
                                            url: supportingDocumentsByCredit,
                                        };
                                    }
                                }else if(typeof supportingDocumentsByCredit === "object"){
                                    if (supportingDocumentsByCredit?.name?.length > 20) {
                                        fileListCredit = {
                                            uid: "-1",
                                            name: "",
                                            status: "done",
                                            url: "",
                                        };
                                    }
                                }
                                else {
                                    console.log("Substring not found");
                                }
                                if (typeof supportingDocumentsBySales === "string") {
                                    if (supportingDocumentsBySales?.length > 20) {
                                        const firstPart = supportingDocumentsBySales?.substring(0, 20);
                                        const lastPart = supportingDocumentsBySales?.substring(supportingDocumentsBySales?.length - 20);
                                        shortenedUrlSales = `${firstPart}...${lastPart}`;
                                        fileListSales = {
                                            uid: "-1",
                                            name: shortenedUrlSales,
                                            status: "done",
                                            url: supportingDocumentsBySales,
                                        };
                                    }
                                } else {
                                    console.log("Substring not found");
                                }
                               
                                if ( fieldName === "supporting_documents_by_credit" && supportingDocumentsByCredit && typeof supportingDocumentsByCredit === "object"){
                                    // field.disabled = true;
                                    field.fileList = [ ];
                                    field.showUploadList = false;
                                }
                                if ( fieldName === "supporting_documents_by_credit" && supportingDocumentsByCredit && typeof supportingDocumentsByCredit === "string"){
                                    // field.disabled = true;
                                    field.fileList = [ fileListCredit];
                                    field.showUploadList = true;
                                }
                                if ( fieldName === "supporting_documents_by_sales" && supportingDocumentsBySales && typeof supportingDocumentsBySales === "string" && field.type === "FILE"){
                                    field.fileList = [fileListSales ];
                                    field.showUploadList = true;
                                }
                                if ( fieldName === "supporting_documents_by_sales" && supportingDocumentsBySales && typeof supportingDocumentsBySales === "object" && field.type === "FILE"){
                                    // field.disabled = true;
                                    field.fileList = [ ];
                                    field.showUploadList = false;
                                }
                                if ( fieldName === "supporting_documents_by_sales" && supportingDocumentsBySales && field.type !== "FILE"){
                                    field.placeholder = shortenedUrlSales || "";
                                }
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )();
                            }).toList()}
                    </div>
                }
            </div>
        </Card>
    );

    handleParameterChange = (index, parameter) => {
        this.setState((prevState) => {
            const updatedData = [...prevState.deviationAgreedData];
            updatedData[index].parameter = parameter;
            updatedData[index].criteria = "";
            updatedData[index].value = "";
            return { deviationAgreedData: updatedData };
        });
    };
   
    handleValueChange = (index, value) => {
        const { deviationAgreedData, deviation_agreed_para } = this.state;
        const selectedParameterData = deviationAgreedData && deviation_agreed_para?.find((option) => option.parameter === deviationAgreedData[index].parameter);
    
        if (selectedParameterData?.input_type === "Number") {
            if (/^$|^0(\.\d{0,2})?$|^[1-9]\d*(\.\d{0,2})?$/.test(value)) {
                this.setState((prevState) => {
                    const updatedData = [...prevState.deviationAgreedData];
                    updatedData[index].value = value;
                    return { deviationAgreedData: updatedData };
                });
            }
        } else {
            this.setState((prevState) => {
                const updatedData = [...prevState.deviationAgreedData];
                updatedData[index].value = value;
                return { deviationAgreedData: updatedData };
            });
        }
    };
    
    
      handleCriteriaChange = (index, criteria) => {
          this.setState((prevState) => {
              const updatedData = [...prevState.deviationAgreedData];
              updatedData[index].criteria = [criteria];
              return { deviationAgreedData: updatedData };
          });
      };

      renderTableColumns() {
          const { deviationAgreedData, deviation_agreed_para } = this.state;
          const {mpaData} = this.props;
          const deviationListData = mpaData?.get("deviation_list")?.toJS();
          return new OrderedMap({
              parameter: {
                  title: "Parameter",
                  dataIndex: "parameter",
                  key: "parameter",
                  width: 120,
                  align: "center",
                  render: (text, record, index) => {
                      const availableParameters = deviation_agreed_para
                          .filter((option) => !deviationAgreedData.some((row) => row.parameter === option.parameter))
                          .map((option) => option.parameter);
                      return(
                          <Select
                              style={{ width: 250 }}
                              value={text || record.parameter}
                              onChange={(value) => {
                                  this.handleParameterChange(index, value);
                              }}
                          >
                              {availableParameters.map((parameter) => (
                                  <Option key={parameter} value={parameter}>
                                      {parameter}
                                  </Option>
                              ))}
                          </Select>
                      );},
              },
              criteria: {
                  title: "Criteria",
                  dataIndex: "criteria",
                  key: "criteria",
                  width: 100,
                  align: "center",
                  render: (text, record, index) => {
                      return(
                          <Select
                              style={{ width: 200 }}
                              value={text || record.criteria}
                              onChange={(value) => {
                                  this.handleCriteriaChange(index, value);
                              }}
                          >
                              {deviation_agreed_para?.find((option) => option.parameter === record.parameter)
                                  ?.criteria?.map((criteria) => (
                                      <Option key={criteria} value={criteria}>
                                          {criteria}
                                      </Option>
                                  ))}
                          </Select>
                      );},
              },
              value: {
                  title: "Value",
                  dataIndex: "value",
                  key: "value",
                  width: 100,
                  align: "center",
                  render: (text, record, index) => {
                      const selectedParameter = record?.parameter;
                      const selectedParameterData = selectedParameter && deviation_agreed_para?.find((option) => option.parameter === selectedParameter);
                      if (selectedParameterData || deviationListData?.length>0) {
                          if (selectedParameterData?.input_type === "Number") {
                              return (
                                  <Input
                                      style={{ width: 200 }}
                                      value={text || record.value || ""}
                                      onChange={(e) => {
                                          this.handleValueChange(index, e.target.value);
                                      }}
                                  />
                              );
                          } else if (selectedParameterData?.input_type === "Dropdown") {
                              return (
                                  <Select
                                      style={{ width: 200 }}
                                      value={text || record.value || ""}
                                      onChange={(value) => {
                                          this.handleValueChange(index, value);
                                      }}
                                  >
                                      {selectedParameterData?.value?.map((value) => (
                                          <Option key={value} value={value}>
                                              {value}
                                          </Option>
                                      ))}
                                  </Select>
                              );
                          } 
                          else if (selectedParameterData?.input_type === "ManyToManyField") {
                              return (
                                  <Select
                                      style={{ width: 200 }}
                                      mode="multiple"
                                      value={text || record.value || []}
                                      onChange={(value) => {
                                          this.handleValueChange(index, value);
                                      }}
                                  >
                                      {this.state.additionalDocs?.map((doc) => (
                                          <Option key={doc} value={doc}>
                                              {doc}
                                          </Option>
                                      ))}
                                  </Select>
                              );
                          }
                      }
                  },
              },
              deleteRow: {
                  title: "Action",
                  dataIndex: "deleteRow",
                  key: "deleteRow",
                  width: 100,
                  align: "center",
                  render: (text, record, index) => (
                      <Button
                          onClick={() => {
                              this.handleDeleteRow(index);
                          }}
                      >
                        Delete
                      </Button>
                  ),
              },
          });
      }
    

handleAddRow = () => {
    this.setState((prevState) => {
        const newRow = {
            s_no: prevState.deviationAgreedData.length + 1,
            parameter: "--",
            criteria: "--",
            value: "--",
        };
        const updatedData = [...prevState.deviationAgreedData, newRow];
        return { deviationAgreedData: updatedData };
    });
};
handleDeleteRow = (index) => {
    this.setState((prevState) => {
        const updatedData = [...prevState.deviationAgreedData];
        updatedData.splice(index, 1); // Remove the row at the specified index
        return { deviationAgreedData: updatedData };
    });
};
render() {
    return (
        <React.Fragment>
            <Form onSubmit={this.onValuesSubmit}>
                <div className={"form-row"}>    
                    <div className={"w-100 pt-10"}>
                        <h3 className={"pt-5 pb-5"}>{"Program Details"}</h3>
                        {this.getDistributorCompanyForm()}
                    </div>
                    <div className={"w-100 pt-10"}>
                        <div className={"d-flex justify-content-space-between"}>
                            <h3 className={"pt-5 pb-5"}>{"Scheme Controls"}</h3>
                        </div>
                        {this.getUserDetailsForm()}
                    </div>
                    <div className={"w-100 pt-10"}>
                        <div className={"d-flex justify-content-space-between"}>
                            <h3 className={"pt-5 pb-5"}>{"Schedule of charges"}</h3>
                        </div>
                        {this.getScheduleCharges()}
                    </div>
                    {this.props.creditPermission && 
                        <>
                        <div className={"w-100 pt-10"}>
                            <div className={"d-flex justify-content-space-between"}>
                                <h3 className={"pt-5 pb-5"}>{"Deviations agreed"}</h3>
                            </div>
                            <div>
                                <Table 
                                    size="middle"
                                    bordered 
                                    showTopSection={false}
                                    data={List(this.state.deviationAgreedData)}
                                    columns={this.renderTableColumns()} 
                                    pagination={false}
                                    className={"inbox-table"}
                                    showFilters={false}
                                    showColumnSelector={false}
                                    noRowSelection={true}
                                />
                                <Button disabled={!this.props.creditPermission} onClick={this.handleAddRow} style={{border:"none", width:"16.4rem"}}>+ Add new deviation parameter</Button>
                            </div>
                        </div>
                    <div className={"w-100 pt-10"}>
                        <div className={"d-flex justify-content-space-between"}>
                            <h3 className={"pt-5 pb-5"}>{"Approval details"}</h3>
                        </div>
                        {this.getApprovalDetails()}
                    </div>
                    </>
                    }
                    <div className={"w-100 pt-10"}>
                        <div className={"d-flex justify-content-space-between"}>
                            <h3 className={"pt-5 pb-5"}>{"Supporting Documents"}</h3>
                        </div>
                        {this.getSupportingDocuments()}
                    </div>
                    <div className={"w-100 pt-10"}>
                        <div className={"d-flex justify-content-space-between"}>
                            <h3 className={"pt-5 pb-5"}>{"Comments"}</h3>
                        </div>
                        {this.getComments()}
                    </div>
                </div>
                {!this.props.disableFields ? (
                    <div className={"d-flex flex-row-reverse"}>
                        <Form.Item>
                            <Button type="primary" disabled={(!(this.props.salesPermission || this.props.creditPermission) || (this.props.creditPermission && ["Approved"].includes(this.props.mpaData?.get("current_status")) || this.props.salesPermission && ["Approved", "Awaiting Approval"].includes(this.props.mpaData?.get("current_status"))))} className={"mt-10"} htmlType={"submit"}>{this.props.loading ? <Icon type={"loading"} /> : null}Submit</Button>
                        </Form.Item>
                    </div>
                ) : null}
            </Form>
        </React.Fragment>
    );
}
}

MpaCreateForm.propTypes = {
    form: PropTypes.object,
    mpaData: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    gstinValidator: PropTypes.object,
    gstinDisabled: PropTypes.bool,
    fetchChannelProducts: PropTypes.func,
    salesManagers: PropTypes.array,
    loading: PropTypes.bool,
    disableFields: PropTypes.bool,
    fetchSalesManagers: PropTypes.func,
    fetchDRMManagers: PropTypes.func,
    loadingFn: PropTypes.func,
    detail: PropTypes.object,
    gstin: PropTypes.string,
    fetchIndustryTypes: PropTypes.func,
    vpSalesManagers: PropTypes.array,
    fetchVpSalesManagers: PropTypes.func,
    companyId: PropTypes.string,
    profile : PropTypes.object,
    deviationAgreedData : PropTypes.object,
    fetchDistributorManagers: PropTypes.func,
    getMpaRequest: PropTypes.func,
    salesPermission: PropTypes.bool,
    creditPermission: PropTypes.bool,
};

CompanyService.defaultProps = {
    salesManagers: [],
    vpSalesManagers: [],
    disableFields: false
};

export default Form.create({
    mapPropsToFields: ({ profile, mpaData }) => {
        let mergedRecord = Immutable.Map();
        if(mpaData){
            mergedRecord = mpaData.merge({gstin: mpaData.getIn(["company", "gstin"]), name: mpaData.getIn(["company", "name"]), type: mpaData.getIn(["data", "type"])});
        }
        if(mpaData == null){
            mergedRecord = mergedRecord.withMutations(record => {
                record
                    .set("name", profile.getIn(["data", "name"]))
                    .set("gstin", profile.getIn(["data", "gstin"]))
                    .set("type", profile.getIn(["data", "type"]));
            });
        }
        return mergedRecord?.map((value, key) => {
            if(key === "approval_date" || key === "ccm_meeting_date") {
                return Form.createFormField({
                    value: value && moment(value)
                });
            }
            if(key === "name") {
                return Form.createFormField({
                    value: profile.getIn(["data", "name"])
                });
            }
            if(key === "gstin") {
                return Form.createFormField({
                    value: profile.getIn(["data", "gstin"])
                });
            }
            if(key === "type") {
                return Form.createFormField({
                    value: COMPANY_TYPES.findKey(_ => _ === profile?.getIn(["data", "type"]))
                });
            }
            if(key === "primary_brand" || key === "industry") {
                return Form.createFormField({
                    value: value?.toJS()
                });
            }
            // if(key === "proposed_tenor" || key === "sbd_days" || key === "subvention_days" ) {
            //     return Form.createFormField({
            //         value: String(value)
            //     });
            // }
            return Form.createFormField({
                value
            });
        }).toJS();
    }
})(MpaCreateForm);